import { render } from "./scrolltotop.vue?vue&type=template&id=619280bd"
import script from "./scrolltotop.vue?vue&type=script&lang=js"
export * from "./scrolltotop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__